export enum LOGIN_TYPE {
  WEB = 'web',
  TABLET = 'tablet',
}
